import { render } from "./SliderNavigation.vue?vue&type=template&id=2f9033aa"
const script = {}

import exportComponent from "/Users/marcin/Local Sites/dermaluce/app/public/wp-content/themes/dermaluce/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__